import React, { useRef } from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { AttachmentsForm } from '../../../components/supplierForm/AttachmentsForm';
import { LegalInformationForm } from '../../../components/supplierForm/LegalInformationForm';
import { EconomicActivityForm } from '../../../components/supplierForm/EconomicActivityForm';
import { LocationForm } from '../../../components/supplierForm/LocationForm';
import { LegalRepresenForm } from '../../../components/supplierForm/LegalRepresenForm';
import { BankingInformationForm } from '../../../components/supplierForm/BankingInformationForm';

import { FinancialInformationForm } from '../../../components/supplierForm/FinancialInformationForm.js';
import { useNavigate } from 'react-router-dom';
import LoadingOverlay from '../../../components/others/LoadingOverlay.js';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient';
import useManageProvider from '../hook/useManageProvider.js';

export const LayoutProvider = () => {
    const navigate = useNavigate();

    const {
        values,
        errorInputs,
        loading,
        isEdit,
        isNitDisabled,
        loadingDian,
        handleGetDianInfo,
        handleInputChange,
        handleDirectInputChange,
        validForm,
        sendNotification,
        save,
        t
    } = useManageProvider();

    const attachmentsRef = useRef();
    const locationRef = useRef();

    const handleSubmit = () => {
        const requiredField = ['identification', 'type_identification', 'business_name', 'society_type', 'company_type', 'supplier_tax_scheme', 'supplier_tax_level_code',
            'type_ciiu', 'code_ciiu', 'description_ciiu', 'reprecentant_type', 'reprecentant_id_type', 'reprecentant_id', 'reprecentant_name', 'type_account',
            'number_account', 'banking_company', 'banking_office', //'total_assets', 'total_liabilities', 'patrimony', 'monthly_income', 'expenses', 'other_income', 'cutoff_date_information'
        ];

        if (validForm(requiredField, values)) {
            save(values);
            Cancel();
        }
        else
            sendNotification({
                msg: t("validation.requiredFieldsMissing"),
                variant: "error",
            });
    };

    const Cancel = () => navigate(-1);

    return (
        <Box sx={{ width: '100%', mx: 'auto' }}>
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        {t("suppliers.suppliersTitle")}
                    </Typography>

                    <AttachmentsForm
                        ref={attachmentsRef}
                        handleInputChange={handleInputChange}
                    />

                    <DividerGradient />

                    <LegalInformationForm
                        dto={values}
                        errorInputs={errorInputs}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                        handleGetDianInfo={handleGetDianInfo}
                        isNitDisabled={isNitDisabled}
                        loadingDian={isNitDisabled}
                        t={t}
                    />

                    <DividerGradient />

                    <EconomicActivityForm
                        dto={values}
                        errorInputs={errorInputs}
                        handleInputChange={handleInputChange}
                        t={t}
                    />

                    <DividerGradient />

                    <LocationForm
                        ref={locationRef}
                        dto={values}
                        isEdit={isEdit}
                        handleDirectInputChange={handleDirectInputChange}
                    />

                    <DividerGradient />

                    <LegalRepresenForm
                        dto={values}
                        errorInputs={errorInputs}
                        handleInputChange={handleInputChange}
                        t={t}
                    />

                    <DividerGradient />

                    <BankingInformationForm
                        dto={values}
                        errorInputs={errorInputs}
                        handleInputChange={handleInputChange}
                        t={t}
                    />

                    <DividerGradient />

                    <FinancialInformationForm
                        dto={values}
                        errorInputs={errorInputs}
                        handleInputChange={handleInputChange}
                        t={t}
                    />

                    <DividerGradient />

                    <ActionButtons
                        onSubmit={handleSubmit}
                        onCancel={Cancel}
                    />
                </CardContent>
            </Card>
            <LoadingOverlay isOpen={loading} />
        </Box >
    );
};
